var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React from 'react';

import PropTypes from 'prop-types';

var Toggle = function (_React$Component) {
  _inherits(Toggle, _React$Component);

  function Toggle(props) {
    _classCallCheck(this, Toggle);

    var _this = _possibleConstructorReturn(this, (Toggle.__proto__ || Object.getPrototypeOf(Toggle)).call(this, props));

    _this.handleChange = _this.handleChange.bind(_this);
    return _this;
  }

  _createClass(Toggle, [{
    key: 'handleChange',
    value: function handleChange(e) {
      if (!this.props.disabled) {
        this.props.onChange(e.target.checked);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var className = 'cf-toggle';

      if (this.props.value) {
        className += ' cf-toggle--active';
      }

      if (this.props.disabled) {
        className += ' cf-toggle--disabled';
      }

      return React.createElement(
        'label',
        { htmlFor: this.props.name, className: className },
        React.createElement('input', {
          className: 'cf-toggle__checkbox',
          type: 'checkbox',
          disabled: this.props.disabled,
          id: this.props.name,
          name: this.props.name,
          checked: this.props.value,
          onChange: this.handleChange,
          onFocus: this.props.onFocus,
          onBlur: this.props.onBlur
        }),
        React.createElement(
          'span',
          { className: 'cf-toggle__label' },
          this.props.label
        ),
        React.createElement('span', { className: 'cf-toggle__handle' })
      );
    }
  }]);

  return Toggle;
}(React.Component);

Toggle.propTypes = {
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.oneOf([false])]).isRequired,
  name: PropTypes.string,
  value: PropTypes.bool,
  onChange: PropTypes.func,
  onFocus: PropTypes.func,
  onBlur: PropTypes.func,
  disabled: PropTypes.bool
};

export default Toggle;


//////////////////
// WEBPACK FOOTER
// ./node_modules/cf-component-toggle/es/Toggle.js
// module id = 776
// module chunks = 0